import axios from "axios";
import { acceptBidUrl, acceptOfferUrl } from "../../utils";

export const acceptOffer = (bidId: string) => {
  return axios.patch(acceptOfferUrl(bidId));
};
